import {lazy} from 'react';
import AppConfig from './appConfig';

const Login = lazy(() => import('../pages/login/Login'));
const Logout = lazy(() => import('../pages/logout/Logout'));
const Home = lazy(() => import('../pages/home/Home'));
const Details = lazy(() => import('../pages/detail/Detail'));
const Glossary = lazy(() => import('../pages/glossary/Glossary'));
const WhatsNew = lazy(() => import('../pages/whatsNew/WhatsNew'));
const NewJoiner = lazy(() => import('../pages/newJoiner/NewJoiner'));
const Result = lazy(() => import('../pages/result/Result'));
const Compare = lazy(() => import('../pages/compare/Compare'));
const RecentlyViewed = lazy(() => import('../pages/recentViewAll/RecentViewAll'));
const ClientData = lazy(() => import('../pages/clientdata/ClientData'));
const DetailsCD = lazy(() => import('../pages/detail/DetailCD'));
const ResultsCD = lazy(() => import('../pages/resultsCD/ResultsCD'));

const Routes = [
  {
    path: '/',
    exact: true,
    component: Home,
    private: true
  },
  {
    path: AppConfig.routePaths.login,
    exact: true,
    component: Login
  },
  {
    path: AppConfig.routePaths.logout,
    exact: true,
    component: Logout
  },
  {
    path: AppConfig.routePaths.home,
    exact: true,
    component: Home,
    private: true
  },
  {
    path: AppConfig.routePaths.details,
    exact: true,
    component: Details,
    private: true
  },
  {
    path: AppConfig.routePaths.glossary,
    exact: true,
    component: Glossary,
    private: true
  },
  {
    path: AppConfig.routePaths.whatsNew,
    exact: true,
    component: WhatsNew,
    private: true,
  },
  {
    path: AppConfig.routePaths.newJoiner,
    exact: true,
    component: NewJoiner,
    private: true,
  },
  {
    path: AppConfig.routePaths.results,
    exact: true,
    component: Result,
    private: true
  },
  {
    path: AppConfig.routePaths.compare,
    exact: true,
    component: Compare,
    private: true
  },
  {
    path: AppConfig.routePaths.recentlyViewAll,
    exact: true,
    component: RecentlyViewed,
    private: true
  },
  {
    path: AppConfig.routePaths.ClientData,
    exact: true,
    component: ClientData,
    private: true
  },
  {
    path: AppConfig.routePaths.detailsCD,
    exact: true,
    component: DetailsCD,
    private: true
  },
  {
    path: AppConfig.routePaths.resultsCD,
    exact: true,
    component: ResultsCD,
    private: true
  },
];
export default Routes;
